module.exports = __webpack_public_path__ + "static/media/m_18.049885c1.png";